var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{class:[
      'has-s-body-size',
      'data',
      { right: _vm.progress < 0.4 }
    ]},[_c('span',[_vm._v(" "+_vm._s(_vm.stars)),(_vm.nextStars)?[_vm._v("/"+_vm._s(_vm.nextStars))]:_vm._e()],2),_c('StarIcon',{class:[
        'star',
        'animate__animated',
        'animate__bounceIn'
      ],attrs:{"filled":""}})],1),_c('div',{staticClass:"progress",style:({ width: ((_vm.progress * 100) + "%") })}),_c('div',{staticClass:"total"})])}
var staticRenderFns = []

export { render, staticRenderFns }